import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'formError'})
export class FormErrorPipe implements PipeTransform {

    constructor() { }

    transform(value: any, args: any): string {
        let messages = [];
        if (value.hasOwnProperty('msg')) {
            messages.push(value['msg']);
        } else {
            for (let err in value) {
                if (value.hasOwnProperty(err)) {
                    switch (err) {
                        case 'required':
                            messages.push('Field is required.');
                            break;
                        case 'minlength':
                            let minLength = value['minlength'].requiredLength;
                            messages.push(`Field must be at least ${minLength} characters.`);
                            break;
                        case 'onlyPositiveInteger':
                            messages.push('Field value must be greater than 0.');
                            break;
                    }
                }
            }
        }

        return messages.join('\n');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/form-error.pipe.ts